'use strict';

import angular from 'angular';

import buttonsModule from './buttons';
import incidentModule from './incident';
import actionToolbarModule from './action-toolbar';
import actionBoxModule from './action-box';
import expansionsModule from './expansions';
import panelOptionsModule from './panel-options';
import logModule from './log';
import activeIncidentsModule from './active-incidents';
import paginationModule from './pagination';
import testCciDirective from './test-cci';
import serviceEventMapModule from './service-event-map';

const MODULE_NAME = 'daupler.incidents.components';

const app = angular.module(MODULE_NAME, [
  buttonsModule,
  incidentModule,
  actionToolbarModule,
  actionBoxModule,
  expansionsModule,
  panelOptionsModule,
  logModule,
  activeIncidentsModule,
  paginationModule,
  serviceEventMapModule,
]);
app.directive('testCci', testCciDirective);

export default MODULE_NAME;
